import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { List, Form, Button } from 'semantic-ui-react'

//utils
import queries from '../../../../src/utils/queries'

import TitDer from '../../../components/funcionales/titder';

const ListaTF = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="tipoFrecuencia" id="miLista7" onChange={(ev)=>handleChange(ev, argsDocum)}>
        <option>Seleccionar...</option>
        <option>Calendario</option>
        <option>Horas</option>
        <option>Km</option>
      </select>
    </div>
  )
};

//dropdown CLASE DE LUBRICANTE
const ListaCL = ({handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="claseLub" id="miLista2" onChange={(ev)=>handleChange(ev)}>
        <option>Seleccionar...</option>
        <option>Mineral</option>
        <option>Sintético</option>
        <option>Vegetal</option>
      </select>
    </div>
  )
};
//FIN dropdown CLASE DE LUBRICANTE
//dropdown CATEGORIAS
const ListaCA = ({handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="categoriaLub" id="miLista3" onChange={(ev)=>handleChange(ev)}>
        <option>Seleccionar...</option>
        <option>H1</option>
        <option>H2</option>
        <option>H3</option>
        <option>3H</option>
      </select>
    </div>
  )
};
//FIN dropdown CATEGORIAS
//dropdown TIPOS DE GRADOS
const ListaTG = ({handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="tipoGrado" id="miLista1" onChange={(ev)=>handleChange(ev)}>
        <option>Seleccionar...</option>
        <option>ISO</option>
        <option>NLGI</option>
        <option>SAE</option>
      </select>
    </div>
  )
};

//dropdown ISO NLGI
const DetalleNivelISO1 = props => {
  return (
    <option dato1={props.elemento.descrGrado} dato2={props.elemento.color} dato3={props.elemento.colorTexto} value={props.elemento._id}>{props.elemento.descrGrado}</option>
  )
};

const ListaISO = ({handleChange, list}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivelISO1 elemento={elemento} key={elemento._id} />);
  let selecc = "Seleccionar..."
  if(list.length===0){
    selecc = "NO SE REQUIERE"
  }
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="isoGrasa" id="miLista41" onChange={(ev)=>handleChange(ev)}>
        <option value="">{selecc}</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//FIN dropdown ISO NLGI

// const ListaApi = ({idLista, argsDocum, permiteUpdate, handleChange}) => {
const ListaApi = ({handleChange}) => {
  return(
    <div>
       <select className="ui simple selection dropdown fluid" name="apiSAE" id="miLista8" onChange={(ev)=>handleChange(ev)}>
      {/* <select className="ui simple selection dropdown fluid" name="apiSAE" id="miLista8" value={permiteUpdate?argsDocum.apiSAE:idLista.apiSAE} onChange={(ev)=>handleChange(ev)}> */}
        {/* <option>S</option>
        <option>C</option>
        <option>G</option> */}
        <option>CH-4</option>
        <option>CI-4</option>
        <option>CJ-4</option> 
        <option>CK-4</option>
        <option>FA-4</option>
        <option>FB</option>   
        <option>FC</option>   
        <option>FD</option> 
        <option>MA</option>   
        <option>MA-1</option>   
        <option>MA-2</option>    
        <option>MB</option>
        <option>SL</option>
        <option>SM</option>
        <option>SN</option> 
        <option>TC-W1</option>   
        <option>TC-W2</option>   
        <option>TC-W3</option>
      </select>
    </div>
  )
};
const ListaApi2 = ({handleChange}) => {
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="apiSAE2" id="miLista9" onChange={(ev)=>handleChange(ev)}>
      {/* <select className="ui simple selection dropdown fluid" name="apiSAE2" id="miLista9" value={permiteUpdate?argsDocum.apiSAE:idLista.apiSAE} onChange={(ev)=>handleChange(ev)}> */}
        {/* <option>S</option>
        <option>C</option>
        <option>G</option> */}
        <option>C-A</option>   
        <option>Dexron IV</option>
        <option>GL-4</option>
        <option>GL-5</option>
        <option>Mercon V</option>           
        <option>MIL-PRF-2105E</option>  
        <option>MT-1</option>  
        <option>SAE J 2360</option>  
        <option>Volth</option>          
        <option>World Spec</option>    
      </select>
    </div>
  )
};

//dropdown TIPOS DE GRADOS
//dropdown GRADOS
const DetalleNivelGR1 = props => {
  // let apiSAE=""
  // if(props.elemento.apiSAE){
  //   apiSAE = " - " + props.elemento.apiSAE
  // }
  return (
    <option dato1={props.elemento.descrGrado} dato2={props.elemento.color} dato3={props.elemento.colorTexto} value={props.elemento._id}>{props.elemento.descrGrado}</option>
    // <option dato1={props.elemento.descrGrado} dato2={props.elemento.apiSAE} dato3={props.elemento.color} dato4={props.elemento.colorTexto} value={props.elemento._id}>{props.elemento.descrGrado}{apiSAE}</option>
  )
};
// console.log(listGr)
//             listGr.sort(function(a, b) {
//               return a - b;
//             })
//             console.log(listGr)


const ListaGR = ({handleChange, list}) => {
  // const unsortedMap = new Map(list)
  // const sortedMap = new Map( [...unsortedMap].sort((x, y) => x[1] - y[1]))
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivelGR1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrGrado" id="miLista4" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//FIN dropdown GRADOS

//dropdown FRECUENCIAS
const DetalleNivelFR1 = props => {
  return (
    <option>{props.elemento.descrFrecuencia}</option>
  )
};

const ListaFR = ({handleChange, list}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivelFR1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrFrecuencia" id="miLista6" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//FIN dropdown FRECUENCIAS


//dropdown APLICACIONES
const DetalleNivelAP1 = props => {
  return (
    <option dato1={props.elemento.descrAplicacion} dato2={props.elemento.color} dato3={props.elemento.tipoGrado} value={props.elemento._id}>{props.elemento.descrAplicacion}</option>
  )
};

const ListaAP = ({handleChange, list}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivelAP1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="descrAplicacion" id="miLista5" onChange={(ev)=>handleChange(ev)}>
        <option value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//FIN dropdown APLICACIONES


class ConfSimRot2 extends React.Component {
  state={argsDocum: {}, listGr: [], listFr: [], listISO: [], listAp: []}

  handleChange = async (ev)=>{
    ev.preventDefault()

// console.log(ev.target.name, ev.target.value)
    const argsDocum = this.state.argsDocum
    argsDocum[ev.target.name] = ev.target.value

    if(ev.target.name === "descrGrado"){
      let miLista = document.getElementById("miLista4");
      // console.log(miLista.options[miLista.selectedIndex].text)
      if(ev.target.value&&ev.target.value!=="Seleccionar..."){
        argsDocum['descrGrado'] = miLista.options[miLista.selectedIndex].attributes[0].value
        // argsDocum['apiSAE'] = miLista.options[miLista.selectedIndex].attributes[1].value
        argsDocum['colorGrado'] = miLista.options[miLista.selectedIndex].attributes[1].value
        argsDocum['colorTexto'] = miLista.options[miLista.selectedIndex].attributes[2].value
      }else{
        delete argsDocum.descrGrado
        // delete argsDocum.apiSAE
        delete argsDocum.colorGrado
        delete argsDocum.colorTexto
      }
      this.setState({argsDocum});
    }else{
      if(ev.target.name === "isoGrasa"){
        let miLista = document.getElementById("miLista41");
        if(ev.target.value&&ev.target.value!=="Seleccionar..."){
          argsDocum['isoGrasa'] = miLista.options[miLista.selectedIndex].attributes[0].value
          argsDocum['isoGrasaColor'] = miLista.options[miLista.selectedIndex].attributes[1].value
          argsDocum['isoGrasaTexto'] = miLista.options[miLista.selectedIndex].attributes[2].value
        }else{
          delete argsDocum.isoGrasa
          delete argsDocum.isoGrasaColor
          delete argsDocum.isoGrasaTexto
        }
        this.setState({argsDocum});
      }
      if(ev.target.name === "descrAplicacion"){
        let miLista = document.getElementById("miLista5");
        let listGr = [], listApi = []        
        if(ev.target.value&&ev.target.value!=="Seleccionar..."){
          // console.log(miLista.options[miLista.selectedIndex].attributes[0].value)
          // console.log(miLista.options[miLista.selectedIndex].attributes[2].value)
          argsDocum['descrAplicacion'] = miLista.options[miLista.selectedIndex].attributes[0].value
          argsDocum['colorAplicacion'] = miLista.options[miLista.selectedIndex].attributes[1].value
          argsDocum['tipoGrado'] = miLista.options[miLista.selectedIndex].attributes[2].value
          if(miLista.options[miLista.selectedIndex].attributes[2].value==="SAE"){
            // console.log(this.props.list1)
            // console.log(miLista.options[miLista.selectedIndex].attributes[2].value)
            if(miLista.options[miLista.selectedIndex].attributes[0].value==="ENGRANAJES AUTOMOTRICES"){
              listGr = await this.props.list1.filter(elemento => elemento.tipoGrado==="SAE" && elemento.aplicacionSAE==="ENGRANAJES AUTOMOTRICES")
              // listApi = ListaApi
            }else{
              listGr = await this.props.list1.filter(elemento => elemento.tipoGrado==="SAE" && elemento.aplicacionSAE==="MOTORES COMBUSTION INTERNA")
              // listApi = ListaApi2
            }          
          }else{
            if(miLista.options[miLista.selectedIndex].attributes[2].value==="NLGI"){
              listGr = await this.props.list1.filter(elemento => elemento.tipoGrado===miLista.options[miLista.selectedIndex].attributes[2].value)
            }else{
              listGr = await this.props.list3.filter(elemento => elemento.tipoGrado===miLista.options[miLista.selectedIndex].attributes[2].value)
            }
          }
          // console.log(listGr)
        }else{ 
          delete argsDocum.descrAplicacion
          delete argsDocum.colorAplicacion
          delete argsDocum.tipoGrado
        }
        this.setState({argsDocum, listGr});
      }else{
        if(ev.target.name === "tipoGrado"){
          let targetValue = ev.target.value
          let listISO = [], listAp = []
          // listGr = await this.props.list1.filter(elemento => elemento.tipoGrado===targetValue)
          if(targetValue==="NLGI"){
            // console.log(this.props.list1)
            listISO = await this.props.list3.filter(elemento => elemento.tipoGrado==="ISO")
            listAp = await this.props.list.filter(elemento => elemento.tipoLub==="Grasa")
          }else{
            listAp = await this.props.list.filter(elemento => elemento.tipoLub==="Aceite" && elemento.tipoGrado===targetValue)
          }

          let miLista = document.getElementById("miLista4");
          miLista.options.selectedIndex = 0
          delete argsDocum.descrGrado
          // delete argsDocum.apiSAE
          delete argsDocum.colorGrado
          delete argsDocum.colorTexto

          miLista = document.getElementById("miLista41");
          miLista.options.selectedIndex = 0
          delete argsDocum.isoGrasa
          delete argsDocum.isoGrasaColor
          delete argsDocum.isoGrasaTexto

          this.setState({argsDocum, listISO, listAp});

        }else{
          if(ev.target.name === "tipoFrecuencia"){
            let targetValue = ev.target.value
            let listFr = []
            listFr = await this.props.list2.filter(elemento => elemento.tipoFrecuencia===targetValue)

            this.setState({argsDocum, listFr});
  
          }else{
            if(ev.target.name === "apiSAE" || ev.target.name === "apiSAE2"){
              argsDocum['apiSAE'] = ev.target.value
            }else{
              this.setState({argsDocum});
            }                  
          }        
        }
      }
    }
  }

  handleSubmit = async (ev)=>{
    let argsDocum = this.state.argsDocum
      console.log(argsDocum)

      let crearRotulo = true
      let figExterna = '', colorBorde = '', colorFigExterna = '', figInterna = '', colorFigInterna = ''
      let isoGrasaColor = '', isoGrasaTexto = ''

      if(argsDocum.descrFrecuencia){
        switch (argsDocum.descrFrecuencia) {
          case 'Cada 8 horas':
            figExterna = '1'
            break;
          case '100 Km':
            figExterna = '1'
            break;
          case 'Cada turno':
            figExterna = '1'
            break;
          case 'Diario':
            figExterna = '2'
            break;
          case '24 horas':
            figExterna = '2'
            break;
          case '250 Km':
            figExterna = '2'
            break;
          case 'Cada 2 días':
            figExterna = '3'
            break;
          case '48 horas':
            figExterna = '3'
            break;
          case '100 horas':
            figExterna = '3'
            break;
          case '500 Km':
            figExterna = '3'
            break;
          case 'Semanal':
            figExterna = '4'
            break;
          case '150 horas':
            figExterna = '4'
            break;
          case '200 horas':
            figExterna = '4'
            break;
          case '1000 Km':
            figExterna = '4'
            break;
          case 'Quincenal':
            figExterna = '5'
            break;
          case '250 horas':
            figExterna = '5'
            break;
          case '300 horas':
            figExterna = '5'
            break;
          case '350 horas':
            figExterna = '5'
            break;          
          case '2000 Km':
            figExterna = '5'
            break;
          case 'Mensual':
            figExterna = '6'
            break;
          case '500 horas':
            figExterna = '6'
            break;
          case '480 horas':
            figExterna = '6'
            break;          
          case '5000 Km':
            figExterna = '6'
            break;          
          case '7000 Km':
            figExterna = '6'
            break;
          case 'Bimestral':
            figExterna = '7'
            break;
          case '1000 horas':
            figExterna = '7'
            break;
          case '1500 horas':
            figExterna = '7'
            break;
          case '10000 Km':
            figExterna = '7'
            break;
          case '15000 Km':
            figExterna = '7'
            break;
          case 'Trimestral':
            figExterna = '8'
            break;
          case '2000 horas':
            figExterna = '8'
            break;
          case '20000 Km':
            figExterna = '8'
            break;
          case 'Cuatrimestral':
            figExterna = '9'
            break;
          case '3000 horas':
            figExterna = '9'
            break;
          case '30000 Km':
            figExterna = '9'
            break;  
          case '40000 Km':
            figExterna = '9'
            break;
          case 'Semestral':
            figExterna = '10'
            break;
          case '4000 horas':
            figExterna = '10'
            break;
          case '50000 Km':
            figExterna = '10'
            break;
          case '60000 Km':
            figExterna = '10'
            break;
          case 'Anual':
            figExterna = '11'
            break;
          case '8000 horas':
            figExterna = '11'
            break;
          case '90000 Km':
            figExterna = '11'
            break;
          case '100000 Km':
            figExterna = '11'
            break;
          case 'Cada 2 años':
            figExterna = '12'
            break;
          case '12000 horas':
            figExterna = '12'
            break;  
          case '16000 horas':
            figExterna = '12'
            break;
          case '20000 horas':
            figExterna = '12'
            break;          
          case '120000 Km':
            figExterna = '12'
            break;
          case '150000 Km':
            figExterna = '12'
            break;
          case '200000 Km':
            figExterna = '12'
            break;
          case 'Cada 3 años':
            figExterna = '13'
            break;
          case '30000 horas':
            figExterna = '13'
            break;
          case '32000 horas':
            figExterna = '13'
            break;          
          case '300000 Km':
            figExterna = '13'
            break;
          case 'Cada 5 años':
            figExterna = '15'
            break;
          case '40000 horas':
            figExterna = '15'
            break;
          case '500000 Km':
            figExterna = '15'
            break;
          case 'Predictiva':
            figExterna = '14'
            break;
          default:
            console.log(argsDocum.descrFrecuencia)
            crearRotulo = false
            break;
        }
      }else{
        console.log("33")
        crearRotulo = false
      }
      if(argsDocum.claseLub){
        switch (argsDocum.claseLub) {
          case 'Mineral':
            colorBorde = 'yellow'
            break;
          case 'Sintético':
            colorBorde = 'blue'
            break;
          case 'Vegetal':
            colorBorde = 'green'
            break;
          default:
            console.log("44")
            crearRotulo = false
            break;
        }
      }else{
        console.log("55")
        crearRotulo = false
      }
      if(argsDocum.colorAplicacion){
        colorFigExterna = argsDocum.colorAplicacion
      }else{
        console.log("66")
        crearRotulo = false
      }
      if(argsDocum.categoriaLub){
        switch (argsDocum.categoriaLub) {
          case 'H1':
            figInterna = '1'
            break;
          case 'H2':
            figInterna = '2'
            break;
          case 'H3':
            figInterna = '3'
            break;
          case '3H':
            figInterna = '4'
            break;
          default:
            console.log("77")
            crearRotulo = false
            break;
        }
      }else{
        console.log("88")
        crearRotulo = false
      }
      if(argsDocum.colorGrado){
        colorFigInterna = argsDocum.colorGrado

        if(argsDocum.tipoGrado==="NLGI"){
          if(argsDocum.isoGrasaColor){
            isoGrasaColor = argsDocum.isoGrasaColor
          }else{
            crearRotulo = false
          }
          if(argsDocum.isoGrasaTexto){
            isoGrasaTexto = argsDocum.isoGrasaTexto
          }else{
            crearRotulo = false
          }
        }
      }else{
        console.log("99")
        crearRotulo = false
      }
//Color del texto
      let colorTexto = ""
      if(argsDocum.colorTexto&&(argsDocum.colorTexto==="BLANCO"||argsDocum.colorTexto==="NEGRO")){
        if(argsDocum.colorTexto==="BLANCO"){
          colorTexto = "#FFFFFF"
        }
        if(argsDocum.colorTexto==="NEGRO"){
          colorTexto = "#000000"
        }
      }else{
        crearRotulo = false
      }
//Color del texto ISO
      if(argsDocum.isoGrasaTexto&&(argsDocum.isoGrasaTexto==="BLANCO"||argsDocum.isoGrasaTexto==="NEGRO")){
        if(argsDocum.isoGrasaTexto==="BLANCO"){
          isoGrasaTexto = "#FFFFFF"
        }
        if(argsDocum.isoGrasaTexto==="NEGRO"){
          isoGrasaTexto = "#000000"
        }
      }

// console.log(figExterna, colorBorde, colorFigExterna, figInterna, colorFigInterna, crearRotulo)
      if(crearRotulo){
        const SVG_NS = "http://www.w3.org/2000/svg"
        let svgrotulo = document.getElementById('svgrotulo')
// console.log(svgrotulo)
        //eliminar todos los child de svgrotulo (limpiar el svg)
        while (svgrotulo.firstChild) {
          svgrotulo.removeChild(svgrotulo.firstChild);
        }

        let objeto = {}
        let sumarPosXFI1 = 0, sumarPosXFI2 = 0, sumarPosXFI3 = 0, sumarPosXFI4 = 0
        let sumarPosYFI1 = 0, sumarPosYFI2 = 0, sumarPosYFI3 = 0, sumarPosYFI4 = 0
        let sumarRadioFI2 = 0, sumarTamFI3y4 = 0
        let sumarPosYNLGI = 0, sumarPosXNLGI = 0, sumarWidthNLGI = 0

        sumarPosXFI1 = 2
        sumarPosYFI1 = 9
        sumarPosYFI2 = 6
        sumarPosYFI3 = 6
        sumarPosYFI4 = 12
        sumarPosXNLGI = 2
        sumarPosYNLGI = 8
        sumarWidthNLGI = sumarPosYFI1

        switch (figExterna) {
          case '1':
            objeto = {cx: 100, cy: 50, rx: 70, ry: 40, fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
            dibujarElementoSVG(objeto, "ellipse", svgrotulo);
            // objeto = {cx: 100, cy: 50, rx: 64, ry: 34, fill: colorFigExterna};
            // dibujarElementoSVG(objeto, "ellipse", svgrotulo);
            
            objeto = {points: '30,50 30,150 170,150 170,50', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
            dibujarElementoSVG(objeto, "polyline", svgrotulo);
            // objeto = {points: '36,50 36,144 164,144 164,50', fill: colorFigExterna};
            // dibujarElementoSVG(objeto, "polyline", svgrotulo);

            break;
          case '2':
            objeto = {cx: 100, cy: 110, rx: 70, ry: 40, fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
            dibujarElementoSVG(objeto, "ellipse", svgrotulo);
            // objeto = {cx: 100, cy: 110, rx: 64, ry: 34, fill: colorFigExterna};
            // dibujarElementoSVG(objeto, "ellipse", svgrotulo);
            
            objeto = {points: '30,110 30,50 100,10 170,50 170,110', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
            dibujarElementoSVG(objeto, "polyline", svgrotulo);
            // objeto = {points: '36,110 36,50 100,16 164,50 164,110', fill: colorFigExterna};
            // dibujarElementoSVG(objeto, "polyline", svgrotulo);

            break;
          case '3':
            objeto = {points: '62,7 30,150 170,150 140,10 58,10', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
            dibujarElementoSVG(objeto, "polyline", svgrotulo);
            // objeto = {points: '66,16 36,144 164,144 134,16 66,16', fill: colorFigExterna};
            // dibujarElementoSVG(objeto, "polyline", svgrotulo);

            break;
          case '4':
            objeto = {x: '30', y: '30', width: '140', height: '105', rx: '40', ry: '40', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
            dibujarElementoSVG(objeto, "rect", svgrotulo);
            // objeto = {x: '36', y: '36', width: '128', height: '88', rx: '40', ry: '40', fill: colorFigExterna};
            // dibujarElementoSVG(objeto, "rect", svgrotulo);

            break;
          case '5':
            objeto = {points: '22,82 100,5 180,82 100,160 18,80', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
            dibujarElementoSVG(objeto, "polyline", svgrotulo);
            // objeto = {points: '26,80 100,6 174,80 100,154 26,80', fill: colorFigExterna};
            // dibujarElementoSVG(objeto, "polyline", svgrotulo);

            break;
          case '6':
            objeto = {x: '30', y: '10', width: '140', height: '140', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
            dibujarElementoSVG(objeto, "rect", svgrotulo);
            // objeto = {x: '36', y: '16', width: '128', height: '128', fill: colorFigExterna};
            // dibujarElementoSVG(objeto, "rect", svgrotulo);

            break;
          case '7':
            objeto = {points: '30,145 30,75 100,5 170,75 170,145 26,145', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
            dibujarElementoSVG(objeto, "polyline", svgrotulo);
            // objeto = {points: '36,144 36,80 100,16 164,80 164,144 36,144', fill: colorFigExterna};
            // dibujarElementoSVG(objeto, "polyline", svgrotulo);

            break;
          case '8':
            sumarPosXFI1 = 5
            sumarPosYFI1 = 9 + 18
            sumarPosYFI2 = 10 + 18
            sumarPosYFI3 = 16 + 18
            sumarTamFI3y4 = 10
            sumarPosYFI4 = 20 + 18
            sumarRadioFI2 = 5
            sumarPosXNLGI = 5
            sumarPosYNLGI = 8 + 18
            sumarWidthNLGI = 11
    
            objeto = {points: '20,150 100,6 180,150 20,150 100,6', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
            dibujarElementoSVG(objeto, "polyline", svgrotulo);
            // objeto = {points: '30,144 100,10 170,144 30,144', fill: colorFigExterna};
            // dibujarElementoSVG(objeto, "polyline", svgrotulo);

            break;

          case '9':
            objeto = {points: '60,150 30,60 100,10 170,60 140,150 57,150', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
            dibujarElementoSVG(objeto, "polyline", svgrotulo);
            // objeto = {points: '36,144 36,80 100,16 164,80 164,144 36,144', fill: colorFigExterna};
            // dibujarElementoSVG(objeto, "polyline", svgrotulo);

            break;

          case '10':
            objeto = {points: '30,81 70,10 130,10 170,80 130,150 70,150 30,79', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
            dibujarElementoSVG(objeto, "polyline", svgrotulo);
            // objeto = {points: '36,80 70,16 130,16 164,80 130,144 70,144 36,80', fill: colorFigExterna};
            // dibujarElementoSVG(objeto, "polyline", svgrotulo);

            break;
          case '11':
            objeto = {points: '30,10 130,10 170,70 170,150 30,150 30,10 130,10', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
            dibujarElementoSVG(objeto, "polyline", svgrotulo);
            // objeto = {points: '36,16 130,16 164,70 164,144 36,144 36,16', fill: colorFigExterna};
            // dibujarElementoSVG(objeto, "polyline", svgrotulo);

            break;
          case '12':
            objeto = {points: '24,10 108,10 170,70 170,150 90,150 28,90 28,10', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
            dibujarElementoSVG(objeto, "polyline", svgrotulo);
            // objeto = {points: '34,16 108,16 164,70 164,144 90,144 34,90 34,16', fill: colorFigExterna};
            // dibujarElementoSVG(objeto, "polyline", svgrotulo);

            break;
          case '13':
            objeto = {points: '57,10 170,10 140,150 30,150 60,7', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
            dibujarElementoSVG(objeto, "polyline", svgrotulo);
            // objeto = {points: '66,16 164,16 136,144 36,144 66,16', fill: colorFigExterna};
            // dibujarElementoSVG(objeto, "polyline", svgrotulo);

            break;
          case '14':
            objeto = {cx: 100, cy: 80, r: 70, fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
            dibujarElementoSVG(objeto, "circle", svgrotulo);
            // objeto = {cx: 100, cy: 80, r: 64, fill: colorFigExterna};
            // dibujarElementoSVG(objeto, "circle", svgrotulo);
            break;
          case '15':
              objeto = {points: '28,135 28,35 168,15 168,135', fill: colorFigExterna, stroke: colorBorde, 'stroke-width': 8};
              dibujarElementoSVG(objeto, "polygon", svgrotulo);
            break;
          default:
            break;
        }

        let tamFuente = 12
        if(argsDocum.tipoGrado!=="NLGI"){
          sumarPosYFI1 -= 6
          sumarPosYFI2 -= 12
          sumarPosYFI3 -= 12
          sumarPosYFI4 -= 6
        }
        let colorBordeInterno=""
        if(colorFigExterna===colorFigInterna){
          if(colorFigExterna==="#000000"){
            colorBordeInterno="#D3D3D3"
          }else{
            colorBordeInterno="#000000"
          }
        }else{
          colorBordeInterno=colorFigInterna
        }
        if(figInterna==='1'){
          objeto = {x: 65+sumarPosXFI1, y: 45+sumarPosYFI1/2+(sumarPosYFI1), width: 70-(sumarWidthNLGI),
                    height: 70-(sumarWidthNLGI), fill: colorFigInterna, stroke: colorBordeInterno, 'stroke-width': 1};
          dibujarElementoSVG(objeto, "rect", svgrotulo);
        }
        if(figInterna==='2'){
          objeto = {cx: 100, cy: 86+sumarPosYFI2, r: 35 - sumarRadioFI2, fill: colorFigInterna, stroke: colorBordeInterno, 'stroke-width': 1};
          dibujarElementoSVG(objeto, "circle", svgrotulo);
        }
        if(figInterna==='3'){
          let posY1 = 120+sumarPosYFI3 - sumarTamFI3y4
          let posY2 = 50+sumarPosYFI3
          objeto = {points: `65,${posY1} 100,${posY2} 135,${posY1} 65,${posY1}`, fill: colorFigInterna, stroke: colorBordeInterno, 'stroke-width': 1};
          dibujarElementoSVG(objeto, "polyline", svgrotulo);
        }
        if(figInterna==='4'){
          objeto = {points: `${65+(sumarTamFI3y4/2)},${80+sumarPosYFI4 - (sumarTamFI3y4/2)} 100,${45+sumarPosYFI4} ${135-(sumarTamFI3y4/2)},${80+sumarPosYFI4 - (sumarTamFI3y4/2)} 100,${115+sumarPosYFI4 - sumarTamFI3y4} ${65+(sumarTamFI3y4/2)},${80+sumarPosYFI4 - (sumarTamFI3y4/2)}`, fill: colorFigInterna, stroke: colorBordeInterno, 'stroke-width': 1};
          dibujarElementoSVG(objeto, "polyline", svgrotulo);

          // objeto = {cx: 100, cy: 80+sumarPosYFI4-ajusteFigExt, r: 35, fill: colorFigInterna};
          // dibujarElementoSVG(objeto, "circle", svgrotulo);
        }

        let ptoX = '100'
        let ptoYL1 = '77', ptoYL2 = '92', ptoYL3 = '107'
        if(argsDocum.tipoGrado==='SAE' && argsDocum.apiSAE.length>9){
          tamFuente = 10
        }

        if(figExterna==='8'){
          ptoYL1 = '103'
          ptoYL2 = '117'
          ptoYL3 = '131'
          if(figInterna==='2'&&argsDocum.tipoGrado==='SAE'&&argsDocum.apiSAE.length>9){
            ptoYL1 = '103'
            ptoYL2 = '113'
            ptoYL3 = '123'
          }
        }
        if(figInterna==='3'&&figExterna!=='8'){
          ptoYL1 = '103'
          ptoYL2 = '113'
          ptoYL3 = '123'
        }
        if(figInterna==='3'&&figExterna==='8'){
          ptoYL1 = '122'
          ptoYL2 = '132'
          ptoYL3 = '142'
        }
        if(figInterna==='4'&&figExterna!=='8'){
          ptoYL1 = '88'
          ptoYL2 = '98'
          ptoYL3 = '108'
        }
        if(figInterna==='4'&&figExterna==='8'){
          ptoYL1 = '110'
          ptoYL2 = '120'
          ptoYL3 = '130'
        }
        if(figInterna==='4'&&figExterna!=='8'&&argsDocum.apiSAE.length>6){
          ptoYL1 = '86'
          ptoYL2 = '95'
          ptoYL3 = '104'
          if(argsDocum.apiSAE.length>9){
            tamFuente = 10
            ptoYL1 = '85'
            ptoYL2 = '93'
            ptoYL3 = '101'
          }
        }
        if(figInterna==='4'&&figExterna==='8'&&argsDocum.apiSAE.length>6){
          ptoYL1 = '108'
          ptoYL2 = '116'
          ptoYL3 = '124'
          if(argsDocum.apiSAE.length>9){
            tamFuente = 10
            ptoYL1 = '105'
            ptoYL2 = '112'
            ptoYL3 = '119'
          }
        }
        if(argsDocum.tipoGrado!=="NLGI"){
          ptoYL1 -= 6
          ptoYL2 -= 6
          ptoYL3 -= 6
          if(figInterna==='3'){
            ptoYL1 -= 12
            ptoYL2 -= 12
            ptoYL3 -= 12
          }
        }

        if(argsDocum.descrGrado){
          objeto = {x: '100', y: ptoYL1, fill: colorTexto, 'font-family': 'Calibri', 'font-size': tamFuente, 
                    'font-weight': 'Bold', 'text-anchor': 'middle'};
          dibujarElementoSVG(objeto, "text", svgrotulo, argsDocum.descrGrado);

      // style="fill: skyblue; stroke: cadetblue; stroke-width: 2;"

          // let elemento = document.createElementNS('http://www.w3.org/2000/svg', 'text');
          // elemento.setAttributeNS(null, 'x', 75);
          // elemento.setAttributeNS(null, 'y', 75);
          // elemento.setAttributeNS(null, 'font-size', 20);
          // elemento.setAttributeNS(null, 'font-weight', 'Bold');
          // elemento.setAttributeNS(null, 'font-family', 'Calibri');
          // var txt = document.createTextNode(argsDocum.descrGrado);
          // elemento.appendChild(txt);
          // svgrotulo.appendChild(elemento);          
        }
        if(argsDocum.tipoGrado){
          objeto = {x: ptoX, y: ptoYL2, fill: colorTexto, 'font-family': 'Calibri', 'font-size': tamFuente, 
                    'font-weight': 'Bold', 'text-anchor': 'middle'};
          dibujarElementoSVG(objeto, "text", svgrotulo, argsDocum.tipoGrado);
          if(argsDocum.tipoGrado==="SAE"){
            objeto = {x: ptoX, y: ptoYL3, fill: colorTexto, 'font-family': 'Calibri', 'font-size': tamFuente, 
                      'font-weight': 'Bold', 'text-anchor': 'middle'};
            dibujarElementoSVG(objeto, "text", svgrotulo, argsDocum.apiSAE);
          }
          if(argsDocum.tipoGrado==="NLGI"){
            objeto = {x: 65+sumarPosXNLGI, y: 33+(sumarPosYNLGI/2)+(sumarPosYNLGI), width: 70-(sumarWidthNLGI),
              height: 14, fill: isoGrasaColor};
            dibujarElementoSVG(objeto, "rect", svgrotulo);

            objeto = {x: ptoX, y: 44+(sumarPosYNLGI/2)+(sumarPosYNLGI), fill: isoGrasaTexto, 'font-family': 'Calibri',
              'font-size': 12, 'font-weight': 'Bold', 'text-anchor': 'middle'};
            dibujarElementoSVG(objeto, "text", svgrotulo, "ISO " + argsDocum.isoGrasa);
          }
        }

        function dibujarElementoSVG(objeto, nombreElemento, elementoPadre, texto) {
          let elemento = document.createElementNS(SVG_NS, nombreElemento);
          for (var nombre in objeto) {
            if (objeto.hasOwnProperty(nombre)) {
              elemento.setAttributeNS(null, nombre, objeto[nombre]);
            }
          }
          if(nombreElemento==="text"){
            let txt = document.createTextNode(texto);
            elemento.appendChild(txt);
          }
          elementoPadre.appendChild(elemento);

          //opcional: la función devuelve el elemento creado para poder utilizarlo más tarde
          // return elemento;
        }

        let svg = svgrotulo
        let svgData = new XMLSerializer().serializeToString( svg );
        let canvas = document.createElement( "canvas" );
        canvas.setAttribute( "height", 200 );
        canvas.setAttribute( "width", 400 );

        let ctx = canvas.getContext( "2d" );
        let img = document.createElement( "img" );
        img.setAttribute( "src", "data:image/svg+xml;base64," + btoa( svgData ) );
        img.onload = function() {
          ctx.drawImage( img, 0, 0 );
          // console.log(figExterna, colorBorde, colorFigExterna, figInterna, colorFigInterna, crearRotulo)

          // Now is done
          let data=canvas.toDataURL( "image/png" )
        }
      }else{
        alert("Datos incompletos para generar el rótulo")
      }
  }

  render(){
    const {listGr, listFr, listISO, listAp, listApi} = this.state;
    const argsDocum = this.state.argsDocum
    // console.log(argsDocum)
    return (
    <div>
      <List selection>
        {/* <TitDer list={list} textBoton1="Empresas" btnNuevo={a010101!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} /> */}
        <TitDer textBoton1="Simulador de rótulos " btnNuevo={"NO"} styles={this.props.styles}/>

        {/* <div> */}
        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <Form name="form1" id="form1" onSubmit={(ev)=>this.handleSubmit(ev)}>   
            <div className="ui two column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '15%', paddingTop: '0.4em'}}>
                  <Form.Field>
                    <label style={{color: '#000046'}}>Tipo de grado</label>
                    <ListaTG handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '35%'}}>
                  <Form.Field>
                    <label style={{color: '#000046'}}>Aplicaciones / Espesantes</label>
                    <ListaAP list={listAp} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>                
                <div className="column" style={{width: '12%', paddingTop: '0.4em'}}>
                  <Form.Field>
                    <label style={{color: '#000046'}}>Grado</label>
                    <ListaGR list={listGr} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
                {argsDocum.tipoGrado==='SAE'&&argsDocum.descrAplicacion!=='ENGRANAJES AUTOMOTRICES' &&
                  <div>
                    <Form.Field>
                      <label style={{color: '#000046'}}>Api SAE</label>
                      <ListaApi styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                    </Form.Field>
                  </div>
                }
                {argsDocum.tipoGrado==='SAE'&&argsDocum.descrAplicacion==='ENGRANAJES AUTOMOTRICES' &&
                  <div>
                    <Form.Field>
                      <label style={{color: '#000046'}}>Api SAE</label>
                      <ListaApi2 styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                    </Form.Field>
                  </div>
                }  
                <div className="column" style={{width: '25%', paddingTop: '0.4em'}}>
                  <Form.Field>
                    <label style={{color: '#000046'}}>ISO</label>
                    <ListaISO list={listISO} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>                
                
                <div className="column" style={{width: '15%', paddingTop: '0.4em'}}>
                  <Form.Field>
                    <label style={{color: '#000046'}}>Clase de lubricante</label>
                    <ListaCL handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '35%'}}>
                  <Form.Field>
                    <label style={{color: '#000046'}}>Categoría</label>
                    <ListaCA handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: "25%"}}>
                  <Form.Field>
                    <label style={{color: '#000046'}}>Tipo de frecuencia</label>
                    <ListaTF handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '25%', paddingTop: '0.4em'}}>
                  <Form.Field>
                    <label style={{color: '#000046'}}>Frecuencia</label>
                    <ListaFR list={listFr} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
              </div>
            </div>
            <p></p>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '100%'}}>
                <Button style={this.props.styles.confirmar} type='submit' fluid>
                  Ver Rótulo
                </Button>
                </div>
              </div>
            </div>
            <p></p>
            <hr></hr>

            <div className="ui two column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '40%'}}>

                </div>
                <div className="column" style={{width: '60%'}}>
                  <svg id='svgrotulo' height='200' width='400'>
                  
                  </svg>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </List>
    </div>
  )
      }
};

export default compose( 
  // graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes2',
  //   options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
  // graphql(queries.mutation.editPlantaEstructura, {name:'editPlantaEstructura'}),
)(ConfSimRot2)
